import { render } from "./videoPlayer.vue?vue&type=template&id=b8abfcce&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&lang=js"
export * from "./videoPlayer.vue?vue&type=script&lang=js"

import "./videoPlayer.vue?vue&type=style&index=0&id=b8abfcce&scoped=true&lang=css"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8abfcce"]])

export default __exports__